<script setup lang="ts">
import type { KsTooltipContentProps, KsTooltipRootEmits, KsTooltipRootProps } from '@aschehoug/kloss-2'
import { KsTooltipContent, KsTooltipProvider, KsTooltipRoot, KsTooltipTrigger, useForwardPropsEmits } from '@aschehoug/kloss-2'

const props = defineProps<Partial<KsTooltipRootProps & KsTooltipContentProps> & { content?: string }>()
const emits = defineEmits<KsTooltipRootEmits>()

const forward = useForwardPropsEmits(props, emits)
</script>

<template>
  <KsTooltipProvider>
    <KsTooltipRoot
      v-bind="forward"
      :delay-duration="200"
    >
      <KsTooltipTrigger as-child>
        <slot />
      </KsTooltipTrigger>
      <KsTooltipContent
        class="z-10 origin-[--reka-tooltip-content-transform-origin] animate-tooltip-in rounded border border-[--theme-40,black] bg-[--theme-5,white] px-2 py-1 text-lg text-[--theme-60,black] shadow"
        align="center"
        :side="props.side"
        :side-offset="5"
      >
        {{ content }}
      </KsTooltipContent>
    </KsTooltipRoot>
  </KsTooltipProvider>
</template>
